import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { Space, Typography } from 'antd'

import { getShopifyBaseUrl } from 'src/utils/helper'

const BlogSection = (): ReactElement => {
  const { t } = useTranslation()
  const baseUrlShopify = getShopifyBaseUrl()
  return (
    <Space direction="vertical">
      <Typography.Title level={3}>
        {t('common:footer.sections.blog')}
      </Typography.Title>
      <a href={`${baseUrlShopify}/blogs/blog`}>
        {t('common:footer.blog.featured')}
      </a>
      <a href={`${baseUrlShopify}/blogs/blog/tagged/lifestyle`}>
        {t('common:footer.blog.lifestyle')}
      </a>
      <a href={`${baseUrlShopify}/blogs/blog/tagged/interviews`}>
        {t('common:footer.blog.interviews')}
      </a>
      <a href={`${baseUrlShopify}/blogs/blog/tagged/tips-tricks`}>
        {t('common:footer.blog.tips_tricks')}
      </a>
      <a href={`${baseUrlShopify}/blogs/blog/tagged/inspiration`}>
        {t('common:footer.blog.inspiration')}
      </a>
    </Space>
  )
}

export default BlogSection
